const WT_GAMES_APP_USER_AGENT = /\bWTGamesApp\b/i;

export const isWtGamesAppUserAgent = (userAgent: string | null | undefined): boolean =>
  typeof userAgent === 'string' && WT_GAMES_APP_USER_AGENT.test(userAgent);
